<template>
  <div class="NoContent204Error">
    <PlatformErrorMessage title="Brak aktywnych projektów"
                          description="Niestety ale nie masz żadnych aktywnych projektów"
    />
    <ShButton class="NoContent204Error__button"
              type="info"
              outline
              @click="handleLogout"
    >
      Wyloguj <i class="fas fa-sign-out-alt"
                 aria-hidden="true"
      />
    </ShButton>
  </div>
</template>

<script>
import PlatformErrorMessage from '@/components/Platform/TheErrorMessage';

export default {
  name: 'NoContent204Error',

  components: {
    PlatformErrorMessage,
  },

  methods: {
    handleLogout() {
      this.$auth.logoutFromPlatform();
    },
  },
};
</script>
<style lang="sass">
.NoContent204Error
  display: flex
  flex-direction: column

  &__button
    align-self: center
    width: 200px

</style>
